import React, { useState } from "react";
import PropTypes from "prop-types";
import SVG from "../../../../components/SVG";
import Api from "../../../../api";

import { Button, ModalView } from "../../../../components/simple";

const ButtonDeleteRegion = ({ className, onClick, id }) => {
  const [isShowRemoveModal, setIsShowRemoveModal] = useState(false);
  const [error, setError] = useState([]);

  const close = () => {
    setIsShowRemoveModal(false);
    setError([]);
  };

  const onRemove = () => {
    onClick();
    close();
  };

  const remove = async () => {
    const res = await Api.audience.deleteInfoRegion({
      data: { id }
    });
    setError(res);
    setIsShowRemoveModal(true);
  };

  return (
    <>
      <button type="button" className={className} onClick={() => remove()}>
        <SVG.Close width={20} height={20} />
      </button>

      <ModalView
        isOpen={isShowRemoveModal}
        toggle={() => {
          setIsShowRemoveModal(close);
        }}
        changeModalState={() => {
          setIsShowRemoveModal(close);
        }}
        handleClose={close}
      >
        <h2 className="title text-center mb-3">Delete region </h2>
        <p className="description mb-4" style={{ textAlign: "center" }}>
          {error.length ? (
            <ul style={{ listStyle: "none" }}>
              <li>
                <h6>
                  Next audiences will be deleted if you delete this region:
                </h6>
              </li>
              {error.map(item => (
                <li key={item.id}>{item.name}</li>
              ))}
            </ul>
          ) : (
            "Are you sure you want to delete the region?"
          )}
        </p>
        <div className="buttons-container">
          <Button
            onClick={onRemove}
            className="button button-danger justify-content-center ml-auto mr-auto mt-4"
          >
            Delete Forever
          </Button>
        </div>
      </ModalView>
    </>
  );
};

ButtonDeleteRegion.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string.isRequired
};

ButtonDeleteRegion.defaultProps = {
  className: "",
  onClick: () => {}
};

export default ButtonDeleteRegion;
